// extracted by mini-css-extract-plugin
export default {"container":"calculator_container__0gSmR","child-container":"calculator_child-container__OIEZG","footer":"calculator_footer__jvIdm","copy":"calculator_copy__ar0qT"};